const constant = {
  primaryColor: "#f08c36",
  greyColor: "#eee",
};

export default constant;
